import { SECTIONS, TOTAL_SCREENS } from "../journey/sections";

const DENOM = TOTAL_SCREENS - 1;

/* Center of each section in screen units (0 = left edge of the
   first screen). The backdrop grade for a section peaks when the
   viewport center sits on this point. */
export const SECTION_CENTERS = (() => {
  let acc = 0;
  return SECTIONS.map((s) => {
    const c = acc + s.screens / 2;
    acc += s.screens;
    return c;
  });
})();

/* Piecewise-linear crossfade between neighboring section centers.
   Returns one weight per section; at most two are non-zero. */
export function gradeWeights(progress) {
  const center = progress * DENOM + 0.5;
  const w = new Array(SECTIONS.length).fill(0);
  const last = SECTION_CENTERS.length - 1;

  if (center <= SECTION_CENTERS[0]) {
    w[0] = 1;
    return w;
  }
  if (center >= SECTION_CENTERS[last]) {
    w[last] = 1;
    return w;
  }
  for (let i = 0; i < last; i++) {
    const a = SECTION_CENTERS[i];
    const b = SECTION_CENTERS[i + 1];
    if (center >= a && center <= b) {
      const t = (center - a) / (b - a);
      w[i] = 1 - t;
      w[i + 1] = t;
      return w;
    }
  }
  w[last] = 1;
  return w;
}
